module.exports = __webpack_public_path__ + "img/21.a15c49e8.gif";